<template lang="pug">
  div
    div(v-if='!saved')
      h6.text-left.mb-0 {{tlang('landing.form_header')}}
      b-tabs(pills justified v-model="tabIndex" active-nav-item-class="bg-secondary")
        b-tab(:title="tlang('landing.phone_tab')"  :title-link-class="linkClass(0)")
          b-form(v-if="form")
            b-input-group
              b-form-input( id='contact_mobile_phone'
                v-model='form.mobile_phone'
                required
                :placeholder="tlang('landing.phone_placeholder')"
                :state='isValid("mobile_phone")'
              )
              b-button(variant="primary" @click="createContact" :disabled='!validData') {{tlang('landing.submit_button')}}
        b-tab(:title="tlang('landing.email_tab')" :title-link-class="linkClass(1)")
          b-form(v-if="form")
            b-input-group
              b-form-input( id='contact_email'
                v-model='form.email'
                type='email'
                required
                :placeholder="tlang('landing.email_placeholder')"
                :state='isValid("mobile_phone")'
              )
              b-input-group-append
                b-button(variant="primary" @click="createContact" :disabled='!validData') {{tlang('landing.submit_button')}}
      b-spinner(v-if='busy' variant="secondary")
      div(v-else)
        b-alert(variant="danger" :show="hasError") {{error}}
        b-alert(variant="secondary" :show="hasMessage") {{message}}
      
    div(v-else)
      b-alert(variant="secondary" :show="hasMessage") {{message}}
</template>

<script>
import {ApiError} from '../common/Api';
import ApiHandlingMixin from '../common/ApiHandlingMixin'
import LangMixin from '../common/lang/util'
export default {
  mixins: [ApiHandlingMixin,LangMixin],
  name: 'Section5Widget',
  data() {
    return {
      saved: false, //contact saved
      form: {
        email: '',
        mobile_phone: ''
      },
      tabIndex: 0,
    };
  },
  computed: {
    validData: function(){
      return this.form && (
        (
          this.form.email 
          && this.form.email.length > 8
          && this.form.email.length < 255
          && this.form.email.includes('@')
          && this.form.email.includes('.')
        ) 
        ||
        (
          this.form.mobile_phone 
          && /[\d]{10,}/.test(this.form.mobile_phone)
        )
      );
    },
    
  },
  methods: {
    validationMessage: function(key){
      return this.errors && this.errors[key] ? this.errors[key] : '';
    },
    isValid:  function(key){
      if( this.validationMessage(key) === '' ) return null;
      return false;
    },
    createContact : async function(){
      try{
        this.in_process ++;
        this.resetMessageState();
        await this.$mobileapi.createContact(this.form);
        this.saved = true;
        this.message = this.tlang('landing.confirmation_text');
            
      }catch(ex){
        if(ex instanceof ApiError){
          if(ex.status === 422){
            //Dupe.
            this.message = this.tlang('landing.confirmation_text');
            this.saved = true;
          } else {
            //Other API
            this.message = ex.message;
            this.error = ex.details.error;
            this.errors = ex.details.errors;
          }
        } else {
          //non API
          console.error(ex);
          this.message = ex.message;
        }
      } finally {
        this.in_process--;
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-secondary', 'text-light']
      } else {
        return ['bg-light', 'text-secondary']
      }
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
